<template>
    <div class="parques">
        <h2 class="subheading grey--text">{{$t('Empresas')}}</h2>
        <v-container class="my-5">
            <v-layout align-center justify-center fill-height>
                <v-dialog
                    v-model="dialogElimnar"
                    max-width="400"
            >
                <v-card>
                    <v-card-title class="headline">
                        {{$t('msg_eliminar_company_associate')}}
                    </v-card-title>
                    <v-card-text>
                        {{$t('msg_eliminar_invitacion_2')}}
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="dialogElimnar = false"
                            >
                                No
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    color="primary"
                                    :loading="loading"
                                    @click="deleteCompanyFromPark()"
                            >
                                {{$t('Si')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card-text>
                </v-card>
            </v-dialog>
                <v-dialog v-model="dialog" persistent max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on " @click="update = false, clean_fields()"> + {{$t('AsociarEmpresa')}}</v-btn>
                    </template>
                    <v-form
                            @submit.prevent="update ? updateEmpresa() : updateEmpresa()">
                        <v-card class="elevation-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>
                                    {{$t('Empresas')}}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn
                                        class="align-self-end"
                                        color="red"
                                        icon
                                        @click="dialog = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <v-autocomplete
                                                v-if="!update"
                                                v-model="idEmpresa"
                                                prepend-icon="business"
                                                name="idEmpresa"
                                                item-text="name"
                                                item-value="id"
                                                :label="$t('Empresa') + ' *'"
                                                :filter="customFilter"
                                                :error-messages="errores.idEmpresa"
                                                :items="empresas"
                                                no-data-text="Ningún Resultado"
                                                clearable
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="numPiso"
                                            prepend-icon="elevator"
                                            :label="$t('num_piso')"
                                            :error-messages="errores.numPiso"
                                        >
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn color="primary" @click="clear(), dialog = false">{{$t('cerrar')}}</v-btn>
                                <v-spacer/>
                                <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{$t('modificar')}}</v-btn>
                                <v-btn v-else :disabled="idEmpresa === '' || idEmpresa === undefined" :loading="loading" color="primary" type="submit">{{$t('asociar')}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-form>
                </v-dialog>
            </v-layout>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{$t('Empresas')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_empresas"
                            :items="companiesByPark"
                            :search="search"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        medium
                                        class="mr-2"
                                        @click="fill_fields(props.item), update = true, dialog = true, id_update = props.item.id"
                                >
                                    edit
                                </v-icon>
                                <v-icon
                                        medium
                                        color="red"
                                        class="mr-2"
                                        @click="dialogElimnar = true, id_update = props.item.id"
                                >
                                    close
                                </v-icon>
                            </td>
                            <td>{{ props.item.name }}</td>
                            <td>{{ props.item.address }}</td>
                            <td>{{ props.item.telephone }}</td>
                            <td>{{ props.item.email }}</td>
                            <td>
                                <v-img :src="props.item.logo">
                                </v-img>
                            </td>
                            <td>{{ props.item.web_page }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import jsPDF from 'jspdf'
    import 'jspdf-autotable'

    Vue.use(VeeValidate)
    import { mapState} from 'vuex'

    export default {
        name: "companiesByPark",
        data: () => ({
            alerta: false,
            parques: [],
            administradores: [],
            companiesByPark: [],
            empresas: [],
            dialog: false,
            update:false,
            id_update: 0,
            idEmpresa: '',
            numPiso: null,
            errores: [],
            search: '',
            headers: [],
            loading_data_empresas: false,
            loading: false,
            yyyy: '',
            mm: '',
            dd: '',
            yyyy2: '',
            mm2: '',
            dd2: '',
            dialogElimnar:false
        }),
        beforeUpdate(){
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'left',
                    sortable: false,
                    value: 'actions'
                },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: this.$t('direccion'),
                    align: 'left',
                    sortable: true,
                    value: 'address'
                },
                {
                    text: this.$t('telefono'),
                    align: 'left',
                    sortable: true,
                    value: 'telephone'
                },
                {
                    text: 'E-Mail',
                    align: 'left',
                    sortable: true,
                    value: 'email'
                },
                {
                    text: this.$t('logotipo'),
                    align: 'left',
                    sortable: true,
                    value: 'logo'
                },
                {
                    text: this.$t('pagina_web'),
                    align: 'left',
                    sortable: true,
                    value: 'web_page'
                }
            ]
        },
        created: function () {
            this.getAllCompaniesNoAssociatePark()
            this.get_parques()
            this.getCompaniesByPark()
        },
        computed: {
            ...mapState(['language'])
        },
        methods: {
            dateFormat(value){
                if (value !== null) {
                    const [year, month, day] = value.split('-')
                    const [dia, hora] = day.split(' ')
                    // console.log(dia, hora)
                    return `${dia}/${month}/${year} ${hora}`
                }
                else return ''
            },
            get_parques(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/parques/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.parques = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            getCompaniesByPark (){
                this.loading_data_empresas = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/parques/empresas',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.companiesByPark = response.data
                        this.loading_data_empresas = false
                    })
                    .catch(error => {
                        this.loading_data_empresas = false
                        console.log(error)
                    })
            },
            getAllCompaniesNoAssociatePark (){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/NoAssociatePark',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.empresas = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            updateEmpresa(){
              console.log('Valor Num de Piso = ', this.numPiso)
              this.loading = true
              let numPisoAux = this.numPiso === null ? '' : this.numPiso.toString().trim()
              let datos = {}
              if (numPisoAux !== '') {
                datos['numPiso'] = numPisoAux
              }
              const config = {
                method: 'patch',
                url: 'https://empresa-service.intrare.app/empresas/parques/Update&Detail&Delete/' + this.idEmpresa + '/',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language ,
                  'authorization': 'Token ' + store.getters.getToken
                },
                data: datos
              }
              axios(config)
                .then(ok => {
                  this.loading = false
                  this.getCompaniesByPark()
                  this.$store.commit('snackbar_activate_true')
                  this.$store.commit('snackbar_change_message', this.$t('mensaje_empresa_asociada_alta'))
                  this.dialog = false
                  setTimeout(this.clear, 3000);
                })
                .catch(error => {
                  this.loading = false
                  if(error.response.status == 400
                    && typeof error.response.data == "object"
                    && error.response.data)
                    this.errores = error.response.data
                })
            },
            deleteCompanyFromPark(){
                this.loading = true
                const config = {
                    method: 'delete',
                    url: 'https://empresa-service.intrare.app/empresas/parques/Update&Detail&Delete/' + this.id_update + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                };
                axios(config).then(ok => {
                    console.log('Empresa Asociado al Parquue Industrial con ID = ', this.id_update + ' ha sido Eliminado Correctamente.')
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', this.$t('mensaje_empresa_asociada_eliminada'))
                    this.loading = false
                    this.getCompaniesByPark()
                    this.getAllCompaniesNoAssociatePark()
                    setTimeout(this.clear, 3000)
                    this.dialogElimnar = false
                })
                    .catch(error => {
                        this.loading = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.$store.commit('snackbar_change_color', 'success')
                this.$store.commit('snackbar_activate_false')
            },
            fill_fields(item){
                this.numPiso = item.numPiso
                this.idEmpresa = item.id
            },
            customFilter (item, queryText) {
                const textOne = item.name.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            clean_fields(){
                this.numPiso = null
                this.idEmpresa = ''
                this.clear()
            },
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            }
        }
    }
</script>
